
import React from 'react';

export const SignupHeader: React.FC = () => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-4">
        <img 
          src="/lovable-uploads/924a6ca1-11fb-46d9-a66b-f6b94a0c23c6.png" 
          alt="ProptPilot Logo" 
          className="w-48 max-w-full h-auto"
          style={{ objectFit: 'contain' }}
        />
      </div>
      <h1 className="text-3xl font-bold">Create your account</h1>
      <p className="mt-2 text-muted-foreground">Join thousands of property managers</p>
    </div>
  );
};
